export default {
  title: 'Event Shop',
  productPage: 'Product Page',
  qty: 'Qty.',
  button: {
    edit: 'Edit',
    add: 'Add to Basket',
  },
};
